export const PAGE_SIZE = 10;
export const PAGE = 1;
export const DATE_FORMAT = {
  JP_DATE: "YYYY年MM月DD日",
  DASH_DATE: "YYYY-MM-DD",
  SLASH_DATE: "YYYY/MM/DD"
};
